import { getGameWorldZoomClampMultiplier } from '@colonist/ui-game';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { Point } from '@colonist/game-mechanic-validators';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameMapViewBoundaries {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.CanvasResized:
                this.updateClamps();
                break;
            default:
                break;
        }
    }
    initMapWorldBoundaries() {
        const hexFaceCartesianLocationXs = [];
        const hexFaceCartesianLocationYs = [];
        const horzHexPackingFactor = 0.5;
        const vertHexPackingFactor = 0.75;
        // tile hexFace coordinates to cartesian rows and columns
        for (const tile of this.uiGameManager.gameState.mapState.tileState.tiles){
            hexFaceCartesianLocationXs.push(tile.hexFace.x + tile.hexFace.y * horzHexPackingFactor);
            hexFaceCartesianLocationYs.push(tile.hexFace.y * vertHexPackingFactor);
        }
        const oceanTileMargin = 1;
        // finding map bounds in cartesian coordinates
        const mapRightMostHexColumn = Math.max(...hexFaceCartesianLocationXs) + oceanTileMargin;
        const mapLeftMostHexColumn = Math.min(...hexFaceCartesianLocationXs) - oceanTileMargin;
        const mapTopMostHexRow = Math.max(...hexFaceCartesianLocationYs) + vertHexPackingFactor * oceanTileMargin;
        const mapBottomMostRow = Math.min(...hexFaceCartesianLocationYs) - vertHexPackingFactor * oceanTileMargin;
        const mapWidthInHexes = mapRightMostHexColumn - mapLeftMostHexColumn + 1;
        const mapHeightInHexes = mapTopMostHexRow - mapBottomMostRow + 1;
        this.mapWidth = this.uiGameManager.mapController.mapView.hexagonWidth * mapWidthInHexes;
        this.mapHeight = this.uiGameManager.mapController.mapView.hexagonHeight * mapHeightInHexes;
        const zoomClampMultiplier = getGameWorldZoomClampMultiplier(UIUtilsEjsVariables.isUserOnMobileAppOrWeb, UIUtilsEjsVariables.shouldDisplayNewMobileGameUI);
        this.uiGameManager.mapController.mapView.worldHeight = this.mapHeight * zoomClampMultiplier;
        this.uiGameManager.mapController.mapView.worldWidth = this.mapWidth * zoomClampMultiplier;
        this.mapHorzOffCenterCorrection = (mapLeftMostHexColumn + mapRightMostHexColumn) * this.uiGameManager.mapController.mapView.hexagonWidth;
        this.mapVertOffCenterCorrection = (mapTopMostHexRow + mapBottomMostRow) * this.uiGameManager.mapController.mapView.hexagonHeight;
    }
    initZoomClamp() {
        const minZoomMultiplier = 3;
        this.uiGameManager.mapController.mapView.clampZoom({
            maxHeight: this.uiGameManager.mapController.mapView.worldHeight,
            maxWidth: this.uiGameManager.mapController.mapView.worldWidth,
            minHeight: this.uiGameManager.mapController.mapView.hexagonHeight * minZoomMultiplier,
            minWidth: this.uiGameManager.mapController.mapView.hexagonWidth * minZoomMultiplier
        });
    }
    centerMapView() {
        this.uiGameManager.mapController.mapView.left = -this.uiGameManager.mapController.mapView.screenWidth / 2 + this.mapHorzOffCenterCorrection;
        this.uiGameManager.mapController.mapView.top = -this.uiGameManager.mapController.mapView.screenHeight / 2 + this.mapVertOffCenterCorrection;
        this.uiGameManager.mapController.mapView.mapCenter = new Point(0 + this.mapHorzOffCenterCorrection / 2, 0 + this.mapVertOffCenterCorrection / 2);
    }
    updateClamps() {
        const { screenWidth, screenHeight } = this.uiGameManager.mapController.mapView;
        const scale = this.uiGameManager.mapController.mapView.scale.x;
        this.resizeClamps(screenWidth / scale, screenHeight / scale);
    }
    resizeClamps(viewWidth, viewHeight) {
        const horzClamp = viewWidth * 2 < this.mapWidth ? this.mapWidth / 2 : viewWidth;
        const vertClamp = viewHeight * 2 < this.mapHeight ? this.mapHeight / 2 : viewHeight;
        this.uiGameManager.mapController.mapView.clamp({
            left: -horzClamp + this.mapHorzOffCenterCorrection,
            right: horzClamp + this.mapHorzOffCenterCorrection,
            top: -vertClamp + this.mapVertOffCenterCorrection,
            bottom: vertClamp + this.mapVertOffCenterCorrection,
            underflow: 'center'
        });
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.initMapWorldBoundaries();
        this.initZoomClamp();
        this.centerMapView();
        this.updateClamps();
        this.uiGameManager.mapController.mapView.on('zoomed', ()=>this.updateClamps());
    }
}
